<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App"
};
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
a {
    color: #000;
    text-decoration: none;
}

body {
    margin: 0;
}
p,
dl,
dt,
dd,
ul,
li,
h1,
h2,
h3,
h4,
h5,
h6 {
    margin: 0;
}
.fl {
    float: left;
}
.fr {
    float: right;
}
.clear:after {
    content: "";
    display: block;
    clear: both;
}
img {
    display: block;
    width: 100%;
    height: auto;
}
.el-carousel__arrow {
    background-color: rgba(31, 45, 61, 0.3) !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff!important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: #fff!important;
    border: 1px solid #e3e3e3;
}

/* .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background: #fff;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue